<app-login-layout>
  <form class="login-form" (ngSubmit)="login()" [formGroup]="loginForm">
    <div class="login-form-header">
      <div class="tunnel-badge">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="currentColor"/>
        </svg>
        Tunnel Display
      </div>
      <div class="login-form-title h6">Log In to Tunnel</div>
      <p class="login-subtitle">Sign in with your tunnel location credentials</p>
    </div>

    <div class="form-group">
      <label for="email" class="form-label">Email<span class="required">*</span></label>
      <input
        type="email"
        class="form-control"
        [ngClass]="{'error': loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)}"
        id="email"
        placeholder="Enter your registered email address"
        formControlName="email"
        (focus)="emailError = ''"
        autocomplete="email"
      />
      <app-error-message *ngIf="loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)">
        Please enter a valid email address.
      </app-error-message>
      <app-error-message *ngIf="emailError">{{ emailError }}</app-error-message>
    </div>

    <div class="form-group">
      <label for="password">Password<span class="required">*</span></label>
      <input
        [type]="showPassword ? 'text' : 'password'"
        id="password"
        placeholder="Enter your password"
        formControlName="password"
        class="form-control"
        [ngClass]="{'error': loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)}"
        (focus)="passwordError = ''"
        autocomplete="current-password"
      />
      <img
        [src]="showPassword ? 'assets/images/eye.svg' : 'assets/images/eye-off.svg'"
        class="eye-icon"
        alt="Toggle password visibility"
        (click)="togglePasswordVisibility()"
      />
      <app-error-message *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)">
        Password is required.
      </app-error-message>
      <app-error-message *ngIf="passwordError">{{ passwordError }}</app-error-message>
    </div>

    <div class="form-group-inline">
      <div class="checkbox-group">
        <input type="checkbox" id="remember" formControlName="rememberMe" class="custom-checkbox" />
        <label class="p5" for="remember">Remember me</label>
      </div>
    </div>

    <button
      type="submit"
      class="login-btn btn btn-primary btn-large"
      [ngClass]="{'disabled': loginForm.invalid || isSubmitting}"
      [disabled]="loginForm.invalid || isSubmitting"
    >
      <span *ngIf="!isSubmitting">Log In</span>
      <span *ngIf="isSubmitting">Signing in...</span>
    </button>

    <div class="privacy-note">
      <img src="/assets/images/Icon-lock.png" alt="Privacy" />
      <div>
        <div class="h10">Your privacy matters to us!</div>
        <p class="p7">We use industry-leading encryption and security measures to keep your information safe.</p>
      </div>
    </div>
  </form>
</app-login-layout>
